import { type CustomFieldType, type CustomFieldValue, isEmpty } from '@terros/common'

export function toNumberCustomFieldValue(value: number | string): CustomFieldType {
  if (typeof value === 'number') return value
  if (isEmpty(value)) return null
  const parsed = Number(value)
  if (Number.isNaN(parsed)) return null
  return parsed
}

export function toDateCustomFieldValue(value: string | null): CustomFieldType {
  if (isEmpty(value)) return null
  const timestamp = new Date(value).getTime()
  if (Number.isNaN(timestamp)) return null
  return timestamp
}

// The server stores an empty array as a value while required-field checks treat it as missing, so clearing sends null
export function toMultiSelectCustomFieldValue(values: string[]): CustomFieldValue {
  if (isEmpty(values)) return null
  return values
}
